import { ReturnDisbursementStatus } from "@redotech/cockroachdb-codegen/tables/returns/return-disbursement-status";
import { CUSTOMER_REFUND_PROVIDERS } from "@redotech/redo-return-core-common/third-party-refunds/recipient";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum GetReturnRefundDestinationErrorCode {
  ReturnNotFound = "ReturnNotFound",
}

/**
 * Where a submitted return's Redo-funded refund is headed. Lives in
 * CockroachDB rather than on the return, so it is read separately.
 */
export const returnRefundDestinationSchema = z.object({
  provider: createEnum(CUSTOMER_REFUND_PROVIDERS),
  /** Both null for a Stripe bank account, which is addressed by an onboarded account rather than contact info. */
  recipient: z.object({
    email: z.string().nullable(),
    phone: z.string().nullable(),
  }),
  status: createEnum(ReturnDisbursementStatus),
  /** False once a payout is in flight or has landed. */
  canEdit: z.boolean(),
});

export type ReturnRefundDestination = z.infer<
  typeof returnRefundDestinationSchema
>;

export const getReturnRefundDestination = {
  name: "getReturnRefundDestination" as const,
  input: z.object({ returnId: zExt.objectId() }),
  /** Null when the return never took a wallet rail. */
  output: z.object({ destination: returnRefundDestinationSchema.nullable() }),
};
